export default {
      id: "notifications__lost-connection-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__lost-connection",
      toString: function () {
        return this.url;
      }
    }